import { FormCompanyName, FormLocation } from '@/components'
import { AssessmentStepKeys, BusinessOrgs } from '@/enums'
import { useNextLoading, useOnNextClick } from '@/providers'
import { splitAtLastIndex } from '@/utils'
import { includes } from 'ramda'
import { useTranslation } from 'react-i18next'
import { useAssessmentValues, useSaveAssessmentStep } from '../helpers'

interface UserProfile {
  name: string
  surname: string
}

interface AssessmentValues {
  userProfile: UserProfile
}

type CompanyDetails = {
  name: string
  address: string
}

const useMessages = () => {
  const { t } = useTranslation()
  return {
    businessName: t('businessName'),
    addressLabel: t('companyDetailsAddressLabel'),
    businessNameInfo: t('businessNameInfo'),
  }
}

export const CompanyDetailsStep = () => {
  const messages = useMessages()
  const {
    values: { userProfile },
  } = useAssessmentValues() as { values: AssessmentValues }

  const modifier = (name: string): string => {
    if (includes(BusinessOrgs.eu, name)) {
      const [init] = splitAtLastIndex(' ', name) as [string]
      return `${init} Inh. ${[userProfile.name, userProfile.surname].join(' ')}`
    }
    return name
  }

  const { save, isLoading } = useSaveAssessmentStep(
    AssessmentStepKeys.companyDetails,
    ((value: CompanyDetails) => ({
      ...value,
      name: modifier(value.name),
    })) as <T>(value: T) => T,
  )

  useOnNextClick(save)

  useNextLoading(() => isLoading, [isLoading])

  return (
    <>
      <FormCompanyName label={messages.businessName} name="name" />
      {/* @ts-expect-error - Ignoring type issue with FormLocation props */}
      <FormLocation label={messages.addressLabel} name="address" />
    </>
  )
}
